/** @jsxImportSource theme-ui */
import React from 'react';
import { SxProp } from 'theme-ui';

import RiskOverviewCardAccordion from 'riskOverview/components/card/RiskOverviewCardAccordion';
import { detailsPanelStyle } from 'riskOverview/components/RiskOverviewStyles';
import RiskOverviewSummary from 'riskOverview/components/summary/RiskOverviewSummary';

type RiskOverviewCardContentProps = SxProp & { diseaseActivityId: number; locationId: number };

const RiskOverviewCardContent: React.FC<RiskOverviewCardContentProps> = ({
  diseaseActivityId,
  locationId,
  ...props
}) => {
  return (
    <div
      sx={{
        display: 'flex',
        flexDirection: ['column', null, 'row'],
        p: ['24px 12px', '32px 24px', '32px'],
      }}
      {...props}
    >
      <RiskOverviewSummary locationId={locationId} diseaseActivityId={diseaseActivityId} />
      <div sx={detailsPanelStyle}>
        <RiskOverviewCardAccordion diseaseActivityId={diseaseActivityId} locationId={locationId} />
      </div>
    </div>
  );
};

export default RiskOverviewCardContent;
